/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  ArchiveSkillRequestBody,
  ArchiveSkillRequestBody$Outbound,
  ArchiveSkillRequestBody$outboundSchema,
} from "../components/archiveskillrequestbody.js";

export type ArchiveSkillSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type ArchiveSkillSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type ArchiveSkillSecurity = {
  option1?: ArchiveSkillSecurityOption1 | undefined;
  option2?: ArchiveSkillSecurityOption2 | undefined;
};

export type ArchiveSkillRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  archiveSkillRequestBody: ArchiveSkillRequestBody;
};

/** @internal */
export type ArchiveSkillSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const ArchiveSkillSecurityOption1$outboundSchema: z.ZodMiniType<
  ArchiveSkillSecurityOption1$Outbound,
  ArchiveSkillSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function archiveSkillSecurityOption1ToJSON(
  archiveSkillSecurityOption1: ArchiveSkillSecurityOption1,
): string {
  return JSON.stringify(
    ArchiveSkillSecurityOption1$outboundSchema.parse(
      archiveSkillSecurityOption1,
    ),
  );
}

/** @internal */
export type ArchiveSkillSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const ArchiveSkillSecurityOption2$outboundSchema: z.ZodMiniType<
  ArchiveSkillSecurityOption2$Outbound,
  ArchiveSkillSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function archiveSkillSecurityOption2ToJSON(
  archiveSkillSecurityOption2: ArchiveSkillSecurityOption2,
): string {
  return JSON.stringify(
    ArchiveSkillSecurityOption2$outboundSchema.parse(
      archiveSkillSecurityOption2,
    ),
  );
}

/** @internal */
export type ArchiveSkillSecurity$Outbound = {
  Option1?: ArchiveSkillSecurityOption1$Outbound | undefined;
  Option2?: ArchiveSkillSecurityOption2$Outbound | undefined;
};

/** @internal */
export const ArchiveSkillSecurity$outboundSchema: z.ZodMiniType<
  ArchiveSkillSecurity$Outbound,
  ArchiveSkillSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => ArchiveSkillSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => ArchiveSkillSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function archiveSkillSecurityToJSON(
  archiveSkillSecurity: ArchiveSkillSecurity,
): string {
  return JSON.stringify(
    ArchiveSkillSecurity$outboundSchema.parse(archiveSkillSecurity),
  );
}

/** @internal */
export type ArchiveSkillRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  ArchiveSkillRequestBody: ArchiveSkillRequestBody$Outbound;
};

/** @internal */
export const ArchiveSkillRequest$outboundSchema: z.ZodMiniType<
  ArchiveSkillRequest$Outbound,
  ArchiveSkillRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    archiveSkillRequestBody: ArchiveSkillRequestBody$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      archiveSkillRequestBody: "ArchiveSkillRequestBody",
    });
  }),
);

export function archiveSkillRequestToJSON(
  archiveSkillRequest: ArchiveSkillRequest,
): string {
  return JSON.stringify(
    ArchiveSkillRequest$outboundSchema.parse(archiveSkillRequest),
  );
}
